export interface TrafficApplyOptions {
  enabled: boolean;
  apiKey?: string;
  attribution?: string;
}

interface TrafficControllerDeps {
  apiKey?: string;
  loadAttribution: (apiKey: string) => Promise<string>;
  apply: (options: TrafficApplyOptions) => void;
  onError?: (error: unknown) => void;
}

/** Coordinates the asynchronous Copyright API caption with synchronous map
 * visibility. One request is shared while pending; a failed request is cleared
 * for the next explicit apply, and generation checks suppress late results. */
export function createTrafficController({ apiKey, loadAttribution, apply, onError }: TrafficControllerDeps): {
  setEnabled: (enabled: boolean) => void;
} {
  let generation = 0;
  let attributionPromise: Promise<string> | undefined;

  return {
    setEnabled(enabled: boolean): void {
      const currentGeneration = ++generation;
      if (!enabled || !apiKey) {
        apply({ enabled: false });
        return;
      }

      const request = attributionPromise ??= loadAttribution(apiKey);
      void request.then((attribution) => {
        if (currentGeneration === generation) apply({ enabled: true, apiKey, attribution });
      }).catch((error: unknown) => {
        // Do not clear a newer retry if an older request rejects late.
        if (attributionPromise === request) attributionPromise = undefined;
        if (currentGeneration === generation) apply({ enabled: false });
        onError?.(error);
      });
    },
  };
}
